import React, { useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
interface DonutData {
  id: string;
  value: number;
  color?: string;
}
interface DonutsProps {
  id: string;
  data: DonutData[];
  colors?: string[];
}

const Donut: React.FC<DonutsProps> = ({ id, data, colors }) => {
  useLayoutEffect(() => {
    // Criar o gráfico
    let chart = am4core.create(id, am4charts.PieChart);

    // Configurações do gráfico
    chart.hiddenState.properties.opacity = 0;
    chart.background.visible = false;

    // Adicionar dados
    chart.data = data.map((item, index) => ({
      ...item,
      color: colors ? colors[index % colors.length] : undefined, // Aplicar cores personalizadas, se fornecidas
    }));

    // Adicionar e configurar a série
    let pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "value";
    pieSeries.dataFields.category = "country";

    // Configurar o raio interno (criar o efeito de rosca)
    chart.innerRadius = am4core.percent(30);

    // Configurar o raio do gráfico
    chart.radius = am4core.percent(50);

    // Configurar as cores das fatias
    pieSeries.slices.template.fillOpacity = 1;
    if (colors) {
      pieSeries.slices.template.propertyFields.fill = "color"; // Usar cores personalizadas
    }

    // Desabilitar rótulos no gráfico
    pieSeries.labels.template.disabled = true;

    // Desabilitar linhas guia dos rótulos
    pieSeries.ticks.template.disabled = true;

    // Configurar o texto do tooltip
    pieSeries.slices.template.tooltipText = "{country}: {value.percent.formatNumber('#.0')}%";
    pieSeries.slices.template.tooltipPosition = "pointer";

    // Limpar o gráfico ao desmontar o componente
    return () => {
      chart.dispose();
    };
  }, [id, data, colors]); // Adicionar `colors` como dependência

  return <div className="chart" id={id}></div>;
};


export default Donut;
